import * as React from 'react';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { Translate } from '../../../../shared/LanguageService';
import UnbookedOrdersList from './UnbookedOrdersList';
import { UnbookedOrder } from '../../types';

type UnbookedOrdersPanelProps = {
    orders: UnbookedOrder[];
    open: boolean;
    showBrokerFirm: boolean;
    returnTo: string;
    onOpenChange: (open: boolean) => void;
};

const TitleId = 'unbooked-orders-title';

function UnbookedOrdersPanel({
    orders,
    open,
    showBrokerFirm,
    returnTo,
    onOpenChange
}: UnbookedOrdersPanelProps) {
    if (!open) {
        return (
            <Paper variant="outlined" sx={{ flexShrink: 0, p: 0.5, borderRadius: 2 }}>
                <Tooltip title={Translate('customer-calendar/unbooked/show')} placement="right">
                    <IconButton
                        aria-label={Translate('customer-calendar/unbooked/show')}
                        aria-expanded={false}
                        onClick={() => onOpenChange(true)}
                    >
                        <Badge badgeContent={orders.length} color="secondary">
                            <EventAvailableIcon />
                        </Badge>
                    </IconButton>
                </Tooltip>
            </Paper>
        );
    }

    return (
        <Paper
            component="aside"
            variant="outlined"
            aria-labelledby={TitleId}
            sx={{
                flexShrink: 0,
                width: 300,
                p: 2,
                borderRadius: 2,
                maxHeight: '80vh',
                overflowY: 'auto'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography id={TitleId} variant="h6" component="h2" sx={{ flex: 1, m: 0 }}>
                    {Translate('customer-calendar/unbooked/title')}
                </Typography>
                <Tooltip title={Translate('customer-calendar/unbooked/hide')}>
                    <IconButton
                        size="small"
                        aria-label={Translate('customer-calendar/unbooked/hide')}
                        aria-expanded
                        onClick={() => onOpenChange(false)}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <UnbookedOrdersList
                orders={orders}
                showBrokerFirm={showBrokerFirm}
                returnTo={returnTo}
            />
        </Paper>
    );
}

export default UnbookedOrdersPanel;
